export enum ReservationWorkflow {
    create = "create",
    edit = "edit",
    copy = "copy",
    prepareShipping = "prepareShipping",
}

export enum ReservationStep {
    requestDetails = 1,
    customerDetails,
    delivery,
    configuration,
    pricing,
    shippingDetails,
    summary,
}
